import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { propTypes } from 'shared/proptypes/Company';
import { createStaticsLink } from 'shared/routes';
import styles from './Header.module.scss';

const CompanyHeader = ({
  company,
  companySizeInline,
  onlyLogo,
  alignInfoTop,
  className
}) => {
  const { t } = useTranslation('userportal');

  const vacanciesLabel = <>{company.jobs.total} {t('page.company.jobsOpened', { postProcess: 'interval', count: company.jobs.total })}</>;

  if (onlyLogo) {
    return (
      <img
        src={createStaticsLink(company.logo)}
        className={cn(styles.onlyLogo, className)}
        title={company.name}
        alt={company.name}
      />
    );
  }

  return (
    <div className={cn(styles.box, className)}>
      {company.logo && (
        <div className={styles.logoWrapper}>
          <img
            src={createStaticsLink(company.logo)}
            title={company.name}
            alt={company.name}
          />
        </div>
      )}
      <div className={cn(styles.info, alignInfoTop ? styles.alignTop : null)}>
        <h1>
          {company.name}
        </h1>
        <div>
          <div className={styles.line}>
            <i className="la la-map-marked-alt" />
            {company.city.title}
          </div>
          <div className={cn(styles.line, !companySizeInline ? styles.wrapSpans : null)}>
            <span>
              <i className="la la-tags" />
              {company.jobs.total > 0 ? (
                <Link to="#vacancies">
                  {vacanciesLabel}
                </Link>
              ) : vacanciesLabel}
            </span>
            {!company.agency && company.size && (
              <span className={cn(styles.size)}>
                <i className="la la-users" />
                {t(`common:companySizeDetail.${company.size}`)}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CompanyHeader.propTypes = {
  company: PropTypes.shape({ ...propTypes, description: PropTypes.string }).isRequired,
  className: PropTypes.string,
  onlyLogo: PropTypes.bool,
  companySizeInline: PropTypes.bool,
  alignInfoTop: PropTypes.bool,
};

CompanyHeader.defaultProps = {
  className: null,
  onlyLogo: false,
  companySizeInline: false,
  alignInfoTop: false,
};

export default CompanyHeader;
